module.exports = __webpack_public_path__ + "static/media/pasabank.7b8776a9.svg";